import React, {Component} from 'react';
import { deFormatDate } from '../../../../lib/mythil/src/time';
import { Calendar } from '../../../components/Calendar/Calendar';
import MessageList from '../MessageList/MessageList';

export default class ResultCalendar extends Component {
    state = {
        results: [],
        normalizedResults: []
    }
    
    static getDerivedStateFromProps(props, state) {
        const { resultValue } = props;

        if (resultValue.results === state.results) {
            return {}
        }

        if (!resultValue.results) {
            return { results: [], normalizedResults: [] }
        }

        const { from_column } = props.calendarView
        return {
            results: resultValue.results,
            normalizedResults: Object.values(resultValue.results).filter((row) => row?.[from_column]?.raw)
        }
    }

    get calendarView() {
        return this.props.calendarView;
    }
    
    getRowActions = () => {
        let actions = [];
        let { trans } = this.props;

        actions.push(
            { label: trans('show'), icon: 'remove_red_eye', onClick: (entry) => this.props.viewEntry(entry) }
        );

        if(this.props.editEntry) {
            actions.push(
                { label: trans('edit'), icon: 'mode_edit', onClick: (entry) => this.props.editEntry(entry) },
            );
        }

        return actions;
    };

    onViewChange = (view) => {
        this.props.updateCalendarView?.(view)
    }

    onCalendarRangeChange = ({ from, to }) => {
        const { filter_name } = this.calendarView;
        this.props.updateCalendarFilter?.(filter_name, {
            min: deFormatDate(from),
            max: deFormatDate(to)
        })
    }

    renderPaginationNotification() {
        if (!this.props.needsPagination) return null;

        return <MessageList messages={[{ message: this.props.trans("calendarLocale.resultsExceedsMaxPages"), }]} className={"test"} hideMessages={ () => {} } />
    }

    render() {
        let { calendarViewConfig, trans } = this.props;

        return (
            <React.Fragment>
            { this.renderPaginationNotification() }
            <Calendar
                trans={trans}
                results={this.state.normalizedResults}
                view={calendarViewConfig?.view}
                calendarView={ this.calendarView }
                onEventClick={this.props.editEntry || this.props.viewEntry}
                // onEventDoubleClick={this.props.editEntry || this.props.viewEntry}
                onViewChange={this.onViewChange}
                onCalendarRangeChange={this.onCalendarRangeChange}
            />
            </React.Fragment>
        );
    }
}